import {
  REQUEST_DB_REPORT_SHOP_SEARCH_DATA, RECEIVE_DB_REPORT_SHOP_SEARCH_DATA, INVALIDATE_DB_REPORT_SHOP_SEARCH_DATA
} from '../../actions/dbreport/ShopSearchAction';

const convertData = (year, data) => {

  let newData = [];
  data.map( item => {

    const yymm = item.yymm.substr(0,4) + '-' + item.yymm.substr(4,2);
    const resultItem = newData.find(element => element.yymm === yymm);

    if(!resultItem){
      let resultItem = {}
      resultItem.yymm = yymm;
      if( item.is_hit === '1' ) resultItem.hit_cnt = item.cnt
      else resultItem.all_cnt = item.cnt;

      newData.push(resultItem);
    }else{

      if( item.is_hit === '1' ) resultItem.hit_cnt = item.cnt
      else resultItem.all_cnt = item.cnt;

      resultItem.hit_rate = Math.round(resultItem.hit_cnt * 100/resultItem.all_cnt) + '%';
    }

  })

  if(!year || year === '2016' || year === '0'){
    newData.push({yymm:'2017-02', hit_cnt: 19, all_cnt: 32, hit_rate: '59%'});
    newData.push({yymm:'2017-03', hit_cnt: 131, all_cnt: 336, hit_rate: '39%'});
  }

  if(!year || year === '2017' || year === '0'){
    newData.push({yymm:'2017-04', hit_cnt: 72, all_cnt: 175, hit_rate: '41%'});
    newData.push({yymm:'2017-05', hit_cnt: 223, all_cnt: 587, hit_rate: '38%'});
  }

  return newData.sort((a,b) => a.yymm > b.yymm);
}
const shopSearchHitrate = (state = {
  isFetching: false,
  didInvalidate: true,
  data: [],
}, action)=> {
  switch(action.type){
    case INVALIDATE_DB_REPORT_SHOP_SEARCH_DATA:
      return { ...state,
        didInvalidate: true
      }
    case REQUEST_DB_REPORT_SHOP_SEARCH_DATA:
      return { ...state,
              isFetching: true,
              didInvalidate: false
            }
    case RECEIVE_DB_REPORT_SHOP_SEARCH_DATA:
      return { ...state,
        isFetching: false,
        didInvalidate: false,
        data: convertData(action.year, action.data),
        lastUpdated: action.receivedAt
      }
    default:
      return state;
  }
}

export default shopSearchHitrate;



// WEBPACK FOOTER //
// ./src/reducers/dbReport/shopSearchHitrate.js